<gbc-tile [title]="tileTitle">
  <div class="title-right" gbc-tile-right>
    <app-last-updated [installationId]="installationId" [applicationId]="applicationId"></app-last-updated>
    @if (showAdjust) {
      <button gbc-icon-button (click)="adjust.emit()" [disabled]="disableAdjust" data-test-id="toggleMultiValueTileAdjust">
        <img src="./assets/svgs/adjust-outline-black.svg" alt="Adjust" />
      </button>
    }
  </div>
  @if (models) {
    <div class="content-container">
      @if (header) {
        <div class="header">{{ header }}</div>
      }
      @for (model of models; track model) {
        <div class="datapoint" [ngClass]="{ bottom: model.isBottom, right: model.isRight }">
          <div class="label">{{ model.titleKey | translate }}</div>
          @if (model.showVisualState) {
            <div class="value-state value">
              <span>{{ (model.value ?? '') | translate }}</span>
              @if (model.showVisualState === 'enabled') {
                <div class="status-badge {{model.visualState}}">
                  <span class="circle {{model.visualState}}"></span>
                  <span>{{ 'multi-value-tile.' + model.visualState | translate }}</span>
                </div>
              }
            </div>
          }
          @if (!model.showVisualState) {
            <div class="value">
              {{ model.value }}
              @if (model.state) {
                @if (model.state === state.Pending) {
                  <img
                    class="status-icon"
                    src="./assets/svgs/data_pending.svg"
                    alt="pending"
                    pTooltip="{{ 'datapoint.syncing' | translate }}"
                    tooltipPosition="right"
                    [escape]="true"
                    />
                }
                @if (model.state === state.Synced) {
                  <img
                    class="status-icon"
                    src="./assets/svgs/data_synced.svg"
                    alt="synced"
                    pTooltip="{{ 'datapoint.synced' | translate }}"
                    tooltipPosition="right"
                    [escape]="true"
                    />
                }
                @if (model.state === state.NotSynced) {
                  <img
                    class="status-icon"
                    src="./assets/svgs/data_notsynced.svg"
                    alt="not-synced"
                    pTooltip="{{ 'datapoint.data-outdated' | translate }}"
                    tooltipPosition="right"
                    [escape]="true"
                    />
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }
</gbc-tile>
